import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Divider,
  Card,
  Fab,
} from "@material-ui/core";
import CitiesTable from "./CitiesTable";
import { usePageStyles } from "../../pageStyles";
import { SearchBox } from "../../components/common/SearchBox";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import AddIcon from "@material-ui/icons/Add";
import { useCitySearch } from "../../../data/listing/cities/hooks/useCitySearch";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components/common/PageTitle";
import { getCityEditLocation } from "./Locations";

const CitiesPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [search, setSearch] = useCitySearch();
  const history = useHistory();

  return (
    <Grid container className={pageStyles.root}>
      <Grid item xs={12} className={pageStyles.gridItem}>
        <Card>
          <CardHeader
            title={<PageTitle title="navCities" />}
            action={<SearchBox search={search} setSearch={setSearch} />}
          />
          <Divider />
          <CardContent>
            <CitiesTable userAccessRights={userAccessRights} />
          </CardContent>
        </Card>
        {userAccessRights === AccessRights.All && (
          <Fab
            color="secondary"
            aria-label="add"
            className={pageStyles.mainFab}
            onClick={() => history.push(getCityEditLocation())}
          >
            <AddIcon />
          </Fab>
        )}
      </Grid>
    </Grid>
  );
};

export default CitiesPage;
